import { key } from 'piqure';
import type { Authentication } from '@/generic/authentication/domain/Authentication.ts';

export const AUTHENTICATION = key<Authentication>('Authentication');
